<template>
  <el-breadcrumb separator="/">
    <template v-for="i in crumbList">
      <el-breadcrumb-item
        v-if="i.path"
        :key="i.id"
        :to="{ path: i.path }"
      >{{i.name}}</el-breadcrumb-item>
      <el-breadcrumb-item
        v-else
        :key="i.id"
      ><a>{{i.name}}</a></el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>

<script>
export default {
  props: {
    crumbList: null,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="less" scoped>
</style>
